import { useAuth } from '../config/auth-provider'

// ============ User Profile ============
// Returns profile data from AuthContext (already fetched on login)
// This eliminates redundant /users/me API calls
export function useProfile() {
  const { user, isLoading, refreshProfile } = useAuth()

  // Return SWR-like interface for compatibility with existing components
  return {
    data: user,
    isLoading,
    error: null,
    mutate: refreshProfile,
  }
}

// ============ Credits ============
// Returns credit info from AuthContext (already included in user profile)
// This eliminates redundant /users/me/credits API calls
export function useCreditInfo() {
  const { user, isLoading, refreshProfile } = useAuth()

  // Return SWR-like interface for compatibility with existing components
  return {
    data: user?.creditInfo,
    isLoading,
    error: null,
    mutate: refreshProfile,
  }
}
